<template>
  <el-dialog
    custom-class="dialog-modal-song" title="CREATE NEW SONG" :model-value="flagVisible" width="770px"
    :before-close="handleClose"
  >
    <div class="modal-create-song text-that-needs-wrapping">
      <div class="create-desc">
        <div class="desc-header">
          <span>Is this song Cross-Comparable or for a single product?</span>
        </div>
        <div class="desc-sub-title">
          <span>Cross-Comparable</span>
        </div>
        <div class="desc-sub-text">
          <span>Do you have songs that compare multiple products under the same conditions on the same sources? That’s a Cross-Comparable song!</span>
        </div>
        <div class="desc-sub-title">
          <span>Single-Product</span>
        </div>
        <div class="desc-sub-text">
          <span>Is this new song for demonstrating just one product? Great – that’s a Single-Product song.</span>
        </div>
      </div>
      <div class="create-type">
        <el-select v-model="songType" placeholder="Select song type" style="width: 100%;">
          <el-option key="1" :value="1" label="New Single-Product song"></el-option>
          <el-option key="2" :value="2" label="New Cross-Comparable song"></el-option>
        </el-select>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button size="small" class="el-btn-blue" :loading="flagLoading.save" @click="handleSave">ADD SONG</el-button>
        <el-button size="small" @click="handleClose">CANCEL</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { reactive } from 'vue'
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal', 'openSongModal'],
  data: function () {
    const flagLoading = reactive({
      save: false
    })
    return {
      songType: 1,
      flagLoading
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    },
    handleSave: function () {
      this.$emit('openSongModal', this.songType)
    }
  }
}
</script>

<style scoped lang="scss">
.modal-create-song {
  color: black;
  .create-desc {
    .desc-header {
      font-size: 22px;
      font-weight: bold;
    }
    .desc-sub-title {
      font-size: 16px;
      font-weight: bold;
      margin-top: 20px;
    }
    .desc-sub-text {
      font-size: 16px;
      margin-top: 20px;
    }
  }
  .create-type {
    padding: 30px 0;
  }
}
</style>
